import { useRef, useEffect } from 'react';
import type { ChatMessage } from '@pullman/shared';
import { MessageBubble } from './MessageBubble';
import { TypingIndicator } from './TypingIndicator';

interface MessageListProps {
  messages: ChatMessage[];
  isStreaming: boolean;
  onSendMessage?: (text: string) => void;
}

export function MessageList({ messages, isStreaming, onSendMessage }: MessageListProps) {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isStreaming]);

  return (
    <div
      className="flex-1 overflow-y-auto px-0 md:px-4 py-6 space-y-4"
      role="log"
      aria-live="polite"
      aria-label="Chat messages"
    >
      {messages.map((msg) => (
        <MessageBubble key={msg.id} message={msg} onSendMessage={onSendMessage} />
      ))}
      {isStreaming && messages.length > 0 && messages[messages.length - 1].content === '' && (
        <TypingIndicator />
      )}
      <div ref={bottomRef} />
    </div>
  );
}
